// extracted by mini-css-extract-plugin
export default {"element":"HorseAndJockeyImg_element__MkXsP","horse":"HorseAndJockeyImg_horse__aE7FZ","jockeyImg":"HorseAndJockeyImg_jockeyImg__pdY+K"};